/** Shared job post status labels used across admin/empresa pages. */
export const JOB_STATUS_LABELS: Record<
  string,
  { label: string; variant: "ready" | "evolution" | "construction" | "outline" }
> = {
  publicada: { label: "Publicada", variant: "ready" },
  em_revisao: { label: "Em Revisão", variant: "evolution" },
  rascunho: { label: "Rascunho", variant: "outline" },
  pausada: { label: "Pausada", variant: "construction" },
  encerrada: { label: "Encerrada", variant: "construction" },
  descartada: { label: "Descartada", variant: "outline" },
  pending_review: { label: "Enriquecendo", variant: "construction" },
};

/** Plain text status labels (used in selects/filters). */
export const JOB_STATUS_TEXT: Record<string, string> = {
  rascunho: "Rascunho",
  em_revisao: "Em Revisão",
  publicada: "Publicada",
  pausada: "Pausada",
  encerrada: "Encerrada",
};

/** Job status color classes (for inline badges without Badge component). */
export const JOB_STATUS_COLORS: Record<string, string> = {
  publicada: "bg-green-100 text-green-800",
  rascunho: "bg-muted text-muted-foreground",
  em_revisao: "bg-yellow-100 text-yellow-800",
  pausada: "bg-yellow-100 text-yellow-800",
  encerrada: "bg-red-100 text-red-800",
  descartada: "bg-muted text-muted-foreground",
  pending_review: "bg-orange-100 text-orange-800",
};

/** Contact request status labels. */
export const CONTACT_STATUS_LABELS: Record<string, string> = {
  requested: "Enviado",
  approved: "Aprovado",
  declined: "Rejeitado",
  waiting_student: "Aguardando Aluno",
  contact_started: "Contato Iniciado",
  closed: "Fechado",
};

/** Contact request status color classes. */
export const CONTACT_STATUS_COLORS: Record<string, string> = {
  requested: "bg-blue-100 text-blue-800",
  approved: "bg-green-100 text-green-800",
  declined: "bg-red-100 text-red-800",
  waiting_student: "bg-purple-100 text-purple-800",
  contact_started: "bg-green-100 text-green-800",
  closed: "bg-muted text-muted-foreground",
};

/** Employment types for job forms. */
export const EMPLOYMENT_TYPES = [
  { label: "Aprendiz", value: "aprendiz" },
  { label: "Estágio", value: "estagio" },
  { label: "Júnior", value: "junior" },
] as const;

/** Base URL for OG tags and sharing links. */
export const BASE_URL = "https://talentcorredigital.lovable.app";

/** Partner type labels used in admin panels. */
export const PARTNER_TYPE_LABELS: Record<string, string> = {
  banco_talentos: "Banco de Talentos",
  vagas: "Vagas",
  doacao_financeira: "Doação Financeira",
  equipamentos: "Equipamentos",
  mentoria: "Mentoria",
  patrocinio: "Patrocínio",
};

/** Work model options for job forms. */
export const WORK_MODELS = [
  { label: "Remoto", value: "remoto" },
  { label: "Presencial", value: "presencial" },
  { label: "Híbrido", value: "hibrido" },
] as const;
